import { createReducer } from 'redux-act';

import {
  PROGRAMME_CATEGORIES_FETCH_DATA_INIT,
  PROGRAMME_CATEGORIES_FETCH_DATA_SUCCESS,
  PROGRAMME_CATEGORIES_FETCH_DATA_FAIL,
  PROGRAMME_CATEGORIES_DELETE_CATEGORY_INIT,
  PROGRAMME_CATEGORIES_DELETE_CATEGORY_SUCCESS,
  PROGRAMME_CATEGORIES_DELETE_CATEGORY_FAIL,
  PROGRAMME_CATEGORIES_CLEAR_DATA,
  PROGRAMME_CATEGORIES_CREATE_CATEGORY_INIT,
  PROGRAMME_CATEGORIES_CREATE_CATEGORY_SUCCESS,
  PROGRAMME_CATEGORIES_CREATE_CATEGORY_FAIL,
  PROGRAMME_CATEGORIES_MODIFY_CATEGORY_INIT,
  PROGRAMME_CATEGORIES_MODIFY_CATEGORY_SUCCESS,
  PROGRAMME_CATEGORIES_MODIFY_CATEGORY_FAIL,
  PROGRAMME_CATEGORIES_CLEAN_UP,
  PROGRAMME_CATEGORIES_CLEAR_DATA_LOGOUT,
  SET_PROGRAMME_CATEGORY,
} from 'state/actions/programmeCategories';

const initialState = {
  list: [],
  programmeCategory: {
    _id: '',
    name: '',
    description: '',
  },
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const programmeCategoriesReducer = createReducer(
  {
    [PROGRAMME_CATEGORIES_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true,
    }),
    [PROGRAMME_CATEGORIES_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      programmeCategory:
        payload.programmeCategory || initialState.programmeCategory,
      loading: false,
      error: null,
    }),
    [PROGRAMME_CATEGORIES_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PROGRAMME_CATEGORIES_DELETE_CATEGORY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PROGRAMME_CATEGORIES_DELETE_CATEGORY_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem._id !== payload.id),
      loading: false,
      error: null,
      deleted: true,
    }),
    [PROGRAMME_CATEGORIES_DELETE_CATEGORY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PROGRAMME_CATEGORIES_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [PROGRAMME_CATEGORIES_CREATE_CATEGORY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PROGRAMME_CATEGORIES_CREATE_CATEGORY_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.concat(payload.category),
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [PROGRAMME_CATEGORIES_CREATE_CATEGORY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PROGRAMME_CATEGORIES_MODIFY_CATEGORY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [PROGRAMME_CATEGORIES_MODIFY_CATEGORY_SUCCESS]: (state, payload) => ({
      ...state,
      list: !state.list
        ? []
        : state.list.map((elem) => {
            if (elem._id === payload.id) {
              return {
                _id: payload.id,
                name: payload.programmeCategory.name,
                description: payload.programmeCategory.description,
                siteId: payload.programmeCategory.siteId,
                modifiedAt: new Date().toDateString(),
                modifiedBy: payload.programmeCategory.modifiedBy,
              };
            }
            return elem;
          }),
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [PROGRAMME_CATEGORIES_MODIFY_CATEGORY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [PROGRAMME_CATEGORIES_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
      updated: false,
    }),
    [PROGRAMME_CATEGORIES_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [SET_PROGRAMME_CATEGORY]: (state, payload) => ({
      ...state,
      programmeCategory: payload.data,
    }),
  },
  initialState
);
